import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState, useRef } from 'react'
import { FaXmark } from 'react-icons/fa6';
import { getAllRegularTicketInstalmentListByTicketId } from '../../service/RegularTicketInstalmentService';


function TicketViewSlideBar({viewingTicket}) {

  const loggedUser = JSON.parse(
      atob(sessionStorage.getItem("x$sk72hyQwersgyhk"))
    );
  
  const [isOpenSlideBar, setIsOpenSlideBar] = useState(false);
  const [ticket, setTicket] = useState('')

  useEffect(()=>{

    if(viewingTicket){
      setTicket(viewingTicket.data)
      setIsOpenSlideBar(true);
      fetchInstalmentTableData(viewingTicket.data)      
    }else{
      setTicket('')
      setIsOpenSlideBar(false);
    }

  },[viewingTicket]);


  //++++ Instalment DataTable  ++++++++++++++++++++++++++++++++
  const instalmentTableRef = useRef();
  const [instalmentTableRowData, setInstalmentTableRowData] = useState([]);
  const [paginationlHide, setPaginationlHide] = useState(true);    
  
  const [instalmentTableColumnDefs, setinstalmentTableColumnDefs] = useState([
    { 
      colId: "id", 
      valueGetter: (r) => r.data.id, 
      flex: 1,
      hide: true 
    },
    {
      colId: "index",
      headerName: "#",
      valueGetter: (r) => r.data.index,
      flex: 0.5,      
    },
    {
      colId: "refNo",
      headerName: "Ref No",
      valueGetter: (r) => r.data.refNo,
      cellStyle: { fontSize: '12px'},       
      flex: 2,      
    },    
    {
      colId: "assortment",
      headerName: "Assortment",
      valueGetter: (r) => r.data.assortment.code,      
      flex: 1,      
    },    
    {
      colId: "insValue",
      headerName: "Ins. Value",
      valueGetter: (r) => r.data.ticket.instalmentValue,      
      flex: 1,
    },
    {
      colId: "addValue",
      headerName: "Add. Value",
      valueGetter: (r) => r.data.ticket.sample.planValue.plan.code != r.data.assortment.cluster.plan.code ? r.data.total-r.data.ticket.instalmentValue:'',      
      flex: 1,     
    },    
    {
      colId: "total",
      headerName: "Total",
      valueGetter: (r) => r.data.total, 
      flex:1,     
    },    
    {
      colId: "paid",
      headerName: "Payment",
      valueGetter: (r) => r.data.paid,
      flex: 1,      
    },    
    {
      colId: "balance",
      headerName: "Balance",
      valueGetter: (r) => r.data.balance,
      flex: 1,      
    },
    {
      colId: "status",
      headerName: "Status",
      valueGetter: (r) => r.data.paymentStatus.replace('_',' '),
      cellStyle: { fontSize: '12px'},   
      flex: 1.2,      
    },
    {
      colId: "paidDate",
      headerName: "Date",
      valueGetter: (r) => r.data.paidDate,
      flex: 1,      
    },    
  ]);




  const fetchInstalmentTableData = async(ticket) =>{
    let installmentRecords = null;

    if(ticket.type === 'Regular'){
      installmentRecords = await getAllRegularTicketInstalmentListByTicketId(loggedUser.token,ticket.id);
      for (let i = 0; i < installmentRecords.data.length; i++) {
        installmentRecords.data[i].index = i + 1;
      }
      setInstalmentTableRowData(installmentRecords.data)
    }else{

    }
  }




  return (
    <div>
      {
          viewingTicket &&
          <div
            className={`absolute top-10 right-0 h-[93.5%] w-[70%] bg-white drop-shadow-[-4px_0_4px_rgba(0,0,0,0.1)] transition-transform duration-2000 ${
              isOpenSlideBar ? 'translate-x-0' : 'translate-x-full hidden'
            }`}                
          >  
            
            <div><button className="p-1" onClick={()=> setIsOpenSlideBar(false)}><FaXmark size={17} className="text-blue-700"/></button></div>
            <h2 className="font-semibold">
              <span className='pl-3'>Ticket : </span>
              <span className='pl-2 text-master_color-600'>{ticket?ticket.ticketCode:''}</span>             
            </h2>
            <hr className='border-slate-300 border-0.5'></hr>
            <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-2 pl-3">Instalment History</div>    
                <div className="ag-theme-quartz h-3/4 px-3 pt-1" style={{ fontSize: '14px' }}> 
                  <AgGridReact
                    ref={instalmentTableRef}
                    columnDefs={instalmentTableColumnDefs}                         
                    rowData={instalmentTableRowData}
                    rowHeight={27}                    
                    rowSelection={"single"}
                    //onSelectionChanged={handledOnRowClick}
                    pagination={false}
                    paginationPageSize={10}
                    paginationPageSizeSelector={[5, 10, 15]}                               
                  />
                </div>
        </div>

      }    
    </div>
  )

}

export default TicketViewSlideBar;